import { useMemo } from "react";
import Markdown from "react-native-markdown-display";
import { Link } from "expo-router";
import { Button } from "@ptsd/uikit";
import { ArrowLeft } from "@tamagui/lucide-icons";
import { useTranslation } from "react-i18next";
import {
  Image,
  Separator,
  Text,
  useMedia,
  View,
  XStack,
  YStack,
} from "tamagui";

import img from "~/assets/onboarding/frame-1.png";
import { Footer, Header } from "./layout";

const GlobalErrorContent: React.FC<{ error?: string }> = ({ error }) => {
  const { t } = useTranslation("errors");

  const errorText = useMemo(() => {
    switch (error) {
      case "FORBIDDEN":
        return t("forbidden");
      default:
        return error;
    }
  }, [error, t]);

  return (
    <View width={"100%"} gap={"$3"} maxWidth={413}>
      <View width={"100%"} gap={"$2"}>
        <Text
          fontFamily={"$subtitle"}
          fontWeight={"$6"}
          fontSize={"$7"}
          lineHeight={"$7"}
        >
          {t("somethingWentWrong")}
        </Text>

        <Markdown
          style={{
            body: { fontFamily: "Fixel Text", fontSize: 18, lineHeight: 22 },
          }}
        >
          {errorText}
        </Markdown>
      </View>
      <Separator borderColor={"$gray-200"} />
      <XStack gap={"$1"}>
        <Link href={"/"} asChild>
          <Button variant="gray" rounded="lg" size="lg" mode="icon">
            <ArrowLeft />
          </Button>
        </Link>

        <Button
          variant="primary"
          width={"100%"}
          size="lg"
          rounded="lg"
          flex={1}
          maxWidth={350}
          onPress={() => {
            if (window) {
              window.location.reload();
            }
          }}
        >
          Оновити сторінку
        </Button>
      </XStack>
    </View>
  );
};

export const GlobalErrorScreen: React.FC<{
  withHeader?: boolean;
  withFooter?: boolean;
  error?: string;
}> = ({ withHeader = false, withFooter = false, error }) => {
  const { sm } = useMedia();

  return (
    <YStack>
      {withHeader && <Header isTutorial />}
      <View
        $sm={{ flex: 1 }}
        flex={2}
        width={"100%"}
        minHeight={"80vh"}
        flexDirection="row"
      >
        <View
          flex={1}
          gap={"$15"}
          paddingTop={"$4"}
          paddingHorizontal={"$2.5"}
          alignItems="flex-end"
          justifyContent="center"
          width={"50%"}
          $gtSm={{ paddingRight: 110 }}
          $sm={{ alignItems: "center", justifyContent: "flex-start" }}
        >
          <GlobalErrorContent error={error} />
        </View>
        {!sm && (
          <View
            paddingHorizontal={"$2.5"}
            width={"50%"}
            alignItems="flex-start"
            paddingLeft={110}
            justifyContent="center"
            flex={1}
          >
            <Image
              maxHeight={460}
              maxWidth={500}
              src={img}
              contain="size"
              width="100%"
              resizeMode="contain"
              aspectRatio={1}
            />
          </View>
        )}
      </View>
      {withFooter && <Footer marginBottom={"$2"} />}
    </YStack>
  );
};
